
export class RoleDefinitions {
    public static readonly admin = 'admin';
    public static readonly faculty = 'faculty';
    public static readonly student = 'student';
    public static readonly guest = 'guest';
  }
  